import { TextField, Typography } from '@mui/material';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import api from '../services/api';
// import FazerObservacoes from '../../../components/fazerObservacoes.';
import RegisterAccess from '../utils/registerAccess';
import Editor from '../ckeditor/editor';
import ButtonLeft from './buttonLeft';
import { useSelector } from 'react-redux';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));

const EnviarNotificacao = (props) => {
    const user = useSelector(state => state.account.user);
    const [obs, setObs] = useState({ conteudo: '' });
    const [load, setLoad] = useState(false);
    const [novoEmail, setNovoEmail] = useState(props.email ?? '');

    const handleClose = () => {
        props.setOpenReenviarEmail('');
    };

    async function senEmail() {
        setLoad(true);
        props.setMessageSuccess('');
        props.setMessageError('');

        const msg = {
            to: novoEmail?.toLowerCase() ?? props.estabelecimento?.email?.toLowerCase(),
            subject: 'Notificação de andamento do processo de licenciamento',
            html: `<h1>O processo está no estado: ${props.estabelecimento?.status}</h1>

            ${obs.conteudo ? `
                </p>
                Observação:
                <br/>
                ${obs.conteudo}
                </p>
                `
                    :
                    ''
                }
    
            <p><b>Nota:</b> Este e-mail foi gerado automaticamente pela plataforma <b>ARMED</b></p>
     `,
        };
        api.post('/email/send', msg)
            .then(response => {
                props.setMessageSuccess('Notificação foi enviado com sucesso.');
                handleCreateobservacao();
                // console.log(response)
            }).catch(err => {

                props.setMessageError(err.response.data.message);
                // console.log(err) 
            }).finally(() => { setLoad(false); props.setOpenReenviarEmail(false); })
    }


    async function handleCreateobservacao() {

        await api.post('/observacao/create', {
            assunto: 'Notificação',
            descricao: obs.conteudo,
            userId: user._id,
            estabelecimentoId: props.estabelecimento._id
        }).then(res => {
            // console.log(res)

        }).catch(error => {
            props.setMessageError(error.response.data.message)
        })
    }

    return (
        <>
            <BootstrapDialog
                scroll='body'
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.openReenviarEmail}
            >
                <RegisterAccess page={'enviar notificação'} />

                <div style={{ padding: 20 }}>

                    <Typography>
                        <strong>Enviar notificação por e-mail</strong>
                        <br />
                        <small>OBS: pode mudar o email</small>
                    </Typography>

                    <TextField
                        fullWidth
                        type='email'
                        size='small'
                        defaultValue={props?.email?.toLowerCase() ?? props.estabelecimento?.email?.toLowerCase()}
                        onChange={(e) => setNovoEmail(e.target.value)} 
                    />


                    {/* EDITOR DE TEXTO CKEditor*/}
                    <Editor
                        setEditorData={setObs}
                        editorData={obs.conteudo}
                    />

                    <ButtonLeft
                        title={'Enviar notificação'}
                        funcao={() => senEmail()}
                        disabled={(!obs.conteudo || !novoEmail)}
                        load={load}
                    />

                </div>
            </BootstrapDialog>
        </>
    );
}

export default EnviarNotificacao;
